import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import axios from "axios";
import { SUBDOMAIN, SUPPORTED_LANGUAGES, USE_WHITELABEL_BRANDING } from "./globals";

const fileExists = async (url: string): Promise<boolean> => {
  try {
    await axios.head(url);
    return true;
  } catch {
    return false;
  }
};

interface TranslationResources {
  [languageCode: string]: {
    translation: object;
  };
}

const mergeTranslations = async (defaultPath: string, customPath: string): Promise<object> => {
  try {
    const defaultResponse = await axios.get(defaultPath);
    const defaultTranslations = defaultResponse.data;

    if (USE_WHITELABEL_BRANDING && SUBDOMAIN === "nj" && (await fileExists(customPath))) {
      const customResponse = await axios.get(customPath);
      const customTranslations = customResponse.data;
      const keys = Object.keys(customTranslations);
      let base = {
        ...defaultTranslations,
        ...customTranslations,
      };
      keys.forEach(
        (key) =>
          (base = { ...base, [key]: { ...defaultTranslations[key], ...customTranslations[key] } })
      );

      return base;
    }
    return defaultTranslations;
  } catch (error) {
    console.error("Error fetching translations:", error);
    // Handle the error or return a default value
    return {};
  }
};

const loadTranslations = async () => {
  const resources: TranslationResources = {};
  const localesDir = "/locales";

  SUPPORTED_LANGUAGES.forEach(async (lng) => {
    const languageCode = lng;
    const defaultPath = `${localesDir}/${languageCode}/translation.json`;
    const customPath = `${localesDir}/${languageCode}/${SUBDOMAIN}_translation.json`;
    const translations = await mergeTranslations(defaultPath, customPath);
    resources[lng] = {
      translation: translations,
    };
  });

  return resources;
};

const initializeI18next = async () => {
  const resources = await loadTranslations();

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: "en",
      debug: true,
      react: {
        useSuspense: false,
      },
    });
};

initializeI18next();

export default i18n;
